import { render, staticRenderFns } from "./DeductionsPlans.vue?vue&type=template&id=645f6516&"
import script from "./DeductionsPlans.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports